import axios from 'axios'

// Shared by cashback and continuous deposits so both wait for the server's
// eligibility decision and display the same rejection/retry behavior.
export default {
  data () {
    return { claimingBonus: false }
  },
  methods: {
    async claimBonus (url, refresh) {
      if (this.claimingBonus) return
      this.claimingBonus = true
      this.$store.commit('user/SET_LOADING', true)
      try {
        const { data } = await axios.get(url)
        if (!data || data.status !== true) {
          await this.$swal({
            icon: 'error',
            title: 'เงื่อนไขการรับโบนัส',
            text: (data && data.message) || 'ยังยืนยันการรับโบนัสไม่ได้ กรุณาลองรายการเดิมอีกครั้ง'
          })
          return
        }
        await refresh()
      } catch (error) {
        await this.$swal({ icon: 'error', title: 'รับโบนัสไม่สำเร็จ', text: 'ยังยืนยันผลไม่ได้ กรุณาลองรายการเดิมอีกครั้ง' })
      } finally {
        this.claimingBonus = false
        this.$store.commit('user/SET_LOADING', false)
      }
    }
  }
}
